var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("leaf",null,{"depth":_vm.treeDepth,"node":_vm.treeItem})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }